import React, { useContext } from 'react';

import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import { RootStoreContext } from 'index';
import { notify } from 'components/common/Toast/toast.helpers';
import { ToastMessage } from 'components/common/Toast/toast.enums';

import styles from './IsNotMyCustomer.module.scss';

interface IsNotMyCustomerPropsType {
  onClose: () => void;
  applicationId: string;
}

const IsNotMyCustomer = ({ onClose, applicationId }: IsNotMyCustomerPropsType) => {
  const { applicationsStore } = useContext(RootStoreContext);
  const handleSubmit = async () => {
    try {
      await applicationsStore.sendIsNotMyCustomer(applicationId);
      onClose();

      notify(ToastMessage.EmailSent, 'success');
    } catch (error: any) {
      notify(error.message, 'error');
    }
  };

  return (
    <div className={styles.container}>
      <p>Are Your Sure You Want to Remove Your Association To This Application?</p>
      <Button className={styles.sendButton} onClick={handleSubmit} isLoading={applicationsStore.isNotMyCustomerLoading}>
        Yes, remove this application
      </Button>
    </div>
  );
};

export default observer(IsNotMyCustomer);
